import {
  Component,
  OnInit,
  Inject,
  ViewChild,
  PLATFORM_ID,
  AfterViewChecked,
  AfterViewInit,
  DOCUMENT
} from "@angular/core";
import { Event, NavigationEnd, Router } from "@angular/router";

import { Location, isPlatformBrowser } from "@angular/common";
import { LandingPageComponent } from "./main/landing-page.component";
import { environment } from "../environments/environment";
import { AuthService } from "./services/auth.service";
import { Environment } from "src/environments/env";
import { E } from "@angular/cdk/keycodes";

declare let gtag: Function;
@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    standalone: false
})
export class AppComponent implements OnInit {
  environment: Environment = environment;
  authorized: boolean = false;
  isHomePage: boolean = false;
  isEmbedRoute: boolean = false;
  isRouteResolved: boolean = false;
  isInitialEmbedRequest: boolean = false;
  failedAttempts: number = 0;
  username: string = "";

  @ViewChild(LandingPageComponent)
  landingPage: LandingPageComponent;

  constructor(
    @Inject(DOCUMENT) private document: any,
    @Inject(PLATFORM_ID) private platformId: any,
    public router: Router,
    private _auth: AuthService
  ) {
    const initialPath = this.document?.location?.pathname ?? "";
    this.isInitialEmbedRequest = initialPath.startsWith("/embed");
    this.isEmbedRoute = this.router.url.startsWith("/embed");

    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.isEmbedRoute = event.urlAfterRedirects.startsWith("/embed");
        this.isRouteResolved = true;
        this.isHomePage = this.router.url == "/";
        if (environment.production) {
          gtag("config", "G-XLV0LECF0F", { page_path: this.router.url });
          gtag("config", "UA-163129211-2", { page_path: this.router.url });
        }
      }
    });

    if (this.router.navigated) {
      this.isRouteResolved = true;
      this.isEmbedRoute = this.router.url.startsWith("/embed");
    }
  }

  authorize() {
    this._auth.check(this.username).then((result) => {
      this.authorized = result;
      if (!this.authorized) {
        this.username = "";
        this.failedAttempts = this._auth.failedAttempts;
      }
    });
  }

  ngOnInit() {
    this._auth.check().then((result) => (this.authorized = result));

    if (!isPlatformBrowser(this.platformId)) {
      let bases = this.document.getElementsByTagName("base");

      if (bases.length > 0) {
        bases[0].setAttribute("href", environment.baseHref);
      }
    }

    if (!isPlatformBrowser(this.platformId)) {
      let bases = this.document.getElementsByTagName("base");

      if (bases.length > 0) {
        bases[0].setAttribute("href", environment.baseHref);
      }
    }
  }
}
